__turbopack_context__.v({
  "ProductList": "ProductList-module__NbfcZG__ProductList",
  "loading": "ProductList-module__NbfcZG__loading",
  "productRow": "ProductList-module__NbfcZG__productRow",
  "pulse": "ProductList-module__NbfcZG__pulse",
});
